<template>
  <div class="this-pricing">
    <div class="title">
      {{ $t('pricing.title') }}
    </div>
    <div class="text">
      {{ $t('pricing.base') }}
    </div>
    <ul class="text">
      <li>{{ $t('pricing.creation') }} 450€</li>
      <li>{{ $t('pricing.testing') }} 220€</li>
    </ul>
  </div>
</template>

<script>
    export default {
        name: 'Pricing',
        props: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';

  .this-pricing {

  }
</style>
